import { render, staticRenderFns } from "./VideoPreview.vue?vue&type=template&id=0900fb99&"
import script from "./VideoPreview.vue?vue&type=script&lang=ts&"
export * from "./VideoPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports